import axios from "axios";

export default class AdminService {
	async addAdmin(name , email , phone , password){
		try {
			const res = await axios({
				method: 'post',
				url: 'dashboard/admin/add',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'name': name,
					'email': email,
					'phone': phone ,
					'password': password
				}
			});
			return res.data;
		} catch (err) {
			console.log(err);
			return err ;
		}		  
	}
	async login(email , password){
		try {
			const res = await axios({
				method: 'post',
				url: 'dashboard/admin/login',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'email': email,
					'password': password
				}
			});
			return res.data;
		} catch (err) {
			console.log(err.response.message);
			return err ;
		}		
	}
	async logout(){
		try {
			const res = await axios({
				method: 'post',
				url: 'dashboard/admin/logout',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
				}
			});
			return res.data;
		} catch (err) {
			console.log(err.response.message);
			return err ;
		}		
	}
	async getStatisctics(){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/statistics',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
				}
			});
			// console.log(res.data)
			return res.data;
		} catch (err) {
			console.log(err.response.message);
			return err ;
		}		
	}
}
